import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css';
import { Grid } from '@splidejs/splide-extension-grid';

const sliders = {
  init() {
    this.textSlider();
    this.prodSlider();
    this.shopCats();
    this.subCats();
    this.brandsSlider();
    this.prodThumbnailsSlider();
    this.prodGallerySlider();
    this.resetSlider();
  },

  resetSlider() {
    window.addEventListener('reset', () => {
      this.prodThumbnailsSlider();
      this.prodGallerySlider();
    });
  },

  textSlider() {
    const sliders = document.querySelectorAll(
      '.jsTextSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        perPage: 1,
        type: 'loop',
        direction: 'ttb',
        pagination: false,
        arrows: false,
        speed: 800,
        heightRatio: 1,
        autoplay: true,
        destroy: true,
        breakpoints: {
          1200: { destroy: false },
        },
      }).mount();
    });
  },

  prodSlider() {
    const sliders = document.querySelectorAll(
      '.jsProdSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'carousel',
        arrows: true,
        gap: 10,
        perPage: 5,
        pagination: false,
        breakpoints: {
          1200: {
            perPage: 2,
            perMove: 1,
            padding: { right: '40%' },
          },
          767: {
            perPage: 1,
            perMove: 1,
            padding: { right: '40%' },
          },
        },
      }).mount();
    });
  },

  brandsSlider() {
    const sliders = document.querySelectorAll(
      '.jsBrandsSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'carousel',
        arrows: true,
        gap: 40,
        perPage: 8,
        pagination: false,
        breakpoints: {
          1200: {
            gap: 20,
            perPage: 4,
            perMove: 1,
            padding: { right: '10%' },
          },

          767: {
            gap: 10,
            perPage: 3,
            perMove: 1,
            padding: { right: '10%' },
          },
        },
      }).mount();
    });
  },

  shopCats() {
    const sliders = document.querySelectorAll(
      '.jsCatSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'carousel',
        perPage: 6,
        arrows: true,
        pagination: false,
        speed: 800,
        gap: '30px',
        breakpoints: {
          1199: {
            perPage: 1,
            grid: {
              rows: 2,
              cols: 3,
              gap: {
                row: '24px',
                col: '24px',
              },
            },
          },
          767: {
            perPage: 1,
            grid: {
              rows: 2,
              cols: 2,
              gap: {
                row: '15px',
                col: '15px',
              },
            },
          },
        },
      }).mount({ Grid });
    });
  },

  subCats() {
    const sliders = document.querySelectorAll(
      '.jsSubCatSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'slide',
        arrows: true,
        gap: 10,
        perPage: 8,
        rewind: true,
        pagination: true,
        breakpoints: {
          1200: {
            perPage: 4,
            perMove: 1,
          },
          767: {
            perPage: 2,
            perMove: 1,
          },
        },
      }).mount();
    });
  },

  prodThumbnailsSlider() {
    const productMainImages = document.getElementById(
      'mainImage',
    ) as HTMLElement | null;
    const thumbnails = document.getElementById(
      'thumbnails',
    ) as HTMLElement | null;

    if (productMainImages) {
      const thumbnailSlides =
        thumbnails?.querySelectorAll('.splide__slide') ?? [];

      const main = new Splide(productMainImages, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: false,
      });

      if (thumbnails && thumbnailSlides.length > 1) {
        thumbnails.classList.remove('thumbnails-hidden');
        thumbnails.classList.add('thumbnails-visible');

        const thumbnailsNav = new Splide(thumbnails, {
          direction: 'ltr',
          isNavigation: true,
          pagination: false,
          perPage: 4,
          arrows: false,
          gap: '20px',
        });

        main.sync(thumbnailsNav);
        main.mount();
        thumbnailsNav.mount();
      } else {
        main.mount();
      }
    }
  },

  prodGallerySlider() {
    const productMainImages = document.getElementById(
      'mainImageGallery',
    ) as HTMLElement | null;
    const thumbnails = document.getElementById(
      'thumbnailsGallery',
    ) as HTMLElement | null;

    if (productMainImages) {
      const thumbnailSlides =
        thumbnails?.querySelectorAll('.splide__slide') ?? [];

      const main = new Splide(productMainImages, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: true,
      });

      if (thumbnails && thumbnailSlides.length > 1) {
        thumbnails.classList.remove('thumbnails-hidden');
        thumbnails.classList.add('thumbnails-visible');

        const thumbnailsNav = new Splide(thumbnails, {
          direction: 'ltr',
          isNavigation: true,
          pagination: false,
          perPage: 4,
          arrows: false,
          gap: '20px',
        });

        main.sync(thumbnailsNav);
        main.mount();
        thumbnailsNav.mount();
      } else {
        main.mount();
      }
    }
  },
};

export default sliders;
